/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { anyMeasuresFindForPiezometrySelected, dataService2, getAllMeasures, getLevelsPr, getPiezoMeasures, piezometersDropdownlistComponent, radioButtonComponent, reformatDate, savePiezoParameter, showHideGraphics } from '../../utils/helpers/view/detailsHelper';
import Error from '../../components/common/ErrorMessage';
import SearchDate from '../../components/common/SearchDate';
import { createGlobalStyle } from 'styled-components';
import { PrMrDetailApi } from '../../utils/api';
import { fetchPov } from '../DetailHelper';
import { LocalStorage } from '../../utils/localStorage';
import { getLastDebitMeasure } from '../../utils/helpers/view/PrDoDetailHelper';
import { getPiezoIds, getPiezoParameter, PrMrGraphicsContainer, verifyPluvioAndPiezoData } from '../../utils/helpers/view/prMrDetailHelper';
import { piezoPluvioInterface } from '../H2SParam/Interface';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { Toast } from 'primereact/toast';
import ResetStyleComponent from '../../components/cssSaur/resetStyleComponent';

const PrMrDetail = () => {
  // variables
  const [lastError, setError] = useState(false);
  const [debit, setDebit] = React.useState<any>();
  const [code] = useState(window.sessionStorage.getItem('Code'));
  const type = window.localStorage.getItem('type')!;
  const [prName, setPrName] = React.useState('');
  const prType = window.localStorage.getItem('PrName');
  const [reziseGraphics, setResizeGraphics] = useState<any>({
    'dataTemps-chart': 'block',
    'dataNombre-chart': 'block',
    'dataVolume-chart': 'block',
    'dataLevels-chart': 'block',
  });
  const [displayHeader, setDisplayHeader] = React.useState<string>('block');
  const [dataSelected, setDataSelected] = React.useState<any>(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
  const [dataToAdd, setDataToAdd] = React.useState<any>(piezoPluvioInterface);
  const [showFilters, setShowFilters] = React.useState<boolean>(false);
  // piezo variables
  const [piezoCarto, setPiezoCarto] = React.useState<any>(null);
  const [piezoSelected, setPiezoSelected] = React.useState<any>(null);
  const [piezoParameter, setPiezoParameter] = React.useState<any>(null);
  const [piezoOptions, setPiezoOptions] = React.useState<any>(null);
  const [allMeasures, setAllMeasures] = React.useState<any>(null);
  const [allMeasuresLevelsPr, setAllMeasuresLevelsPr] = React.useState<any>(null);
  const [piezoMeasures, setPiezoMeasures] = React.useState<any>(null);
  // pluvie variables
  const [idPov, setIdPov] = useState<string | null>(null);
  // toast
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);
 
  //observer store
  dataService2.getError().subscribe((errorState: any) => {
    setError(errorState);
  });

  // we need to refresh those data when the dates are changed
  const getDataForGraphics = async (pDates: any) => {
    // reset all data
    setAllMeasures(null);
    setAllMeasuresLevelsPr(null);
    setPiezoMeasures(null);
    setPiezoSelected(null);
    setPiezoOptions(null);
    setShowFilters(false);
    setDataSelected(piezoPluvioInterface.filter((p) => p.id === 3)[0]);

    // api calls
    getLastDebitMeasure(code,  PrMrDetailApi, setDebit);
    getAllMeasures(PrMrDetailApi, type, window.sessionStorage.getItem("Code"), reformatDate(pDates.start), reformatDate(pDates.end)).then((response) => {
      setAllMeasures(response.data);
    });
    getLevelsPr(code, reformatDate(pDates.start), reformatDate(pDates.end)).then((response) => {
      setAllMeasuresLevelsPr(response);
    });
    getPiezoIds(code).then((piezoListItems) => {
      setPiezoCarto(piezoListItems.length > 0 ? piezoListItems.map((p: any) => p.attributes) : []);
      if(piezoListItems.length > 0) {
        const piezoList = piezoListItems.map((p: any) => p.attributes.WaterTableStationCode).join(",");
        getPiezoMeasures(piezoList, reformatDate(pDates.start), reformatDate(pDates.end)).then((response) => {
          piezoListItems.forEach((i: any) => {
            if(response.find((e) => i.attributes.WaterTableStationCode === e.code) === undefined) {
              response.push({ code: i.attributes.WaterTableStationCode, measures: [] });
            }
          });
          setPiezoMeasures(response);
        });
      } else {
        setPiezoMeasures([]);
      }
    });
    getPiezoParameter(code).then((piezoParameter) => {
      if(piezoParameter !== undefined) {
        setPiezoParameter(piezoParameter);
        setPiezoSelected(piezoParameter.bssId === null ? null : piezoParameter.bssId);
      }
    });
  };

  useEffect(() => {
    if (piezoMeasures !== null && allMeasures !== null) {
      // manage radio buttons
      const updateFilters = verifyPluvioAndPiezoData(allMeasures.pluvioList, piezoMeasures);
      // keep order of piezoCarto data, create dropdownlist of piezometers with measures
      let piezoOptions: any = [];
      piezoCarto.map((p: any, i: number) => {
        if((piezoMeasures ?? []).find((piezo) => piezo.code === p.WaterTableStationCode) !== undefined){
          piezoOptions.push( { 
            id: i, 
            label: p.WaterTableStationCode + ' (' + p.Distance.toLocaleString() + 'm)', 
            value: p.WaterTableStationCode 
          });
        }
      });
      setPiezoOptions(piezoOptions);
      setDataToAdd(updateFilters.interfaceValues);
      setShowFilters(updateFilters.showHideFilters);
    }
    fetchPov(code).then((pov) => setIdPov(pov));
  }, [piezoMeasures, allMeasures]);

  useEffect(() => {
    const name = LocalStorage.prName.get();
    if (name !== null) {
      setPrName(name.toString());
    }
  }, []);

  const handleShowHideGraphics = (pGraphicToGrow: string, pMode: string) => {
    setResizeGraphics(showHideGraphics(pGraphicToGrow, pMode));
    setDisplayHeader(pMode === 'hide' ? 'none' : 'block');
  };

  const warningMessageCss = {
      color: 'red',
      fontSize: '14px',
  }

  return (
    <>
      <Container className='sds-reset-style global-pr-container'>
        <ResetStyleComponent />
          {lastError ? <Error IsVisible={lastError}></Error> : null}
          <Styles />
          <Toast id='toast-success' ref={toastSucess} />
          <Toast id='toast-error' ref={toastError} />
          <Word
            textStyle='title'
            automatedTestId='global-pr-name'
            variant='h1'
            value={prName.toUpperCase()}
          />
          <div style={{ display: displayHeader, alignItems: 'center' }}>
            <div className='search-detail-pr'>
              <SearchDate
                sendDates={getDataForGraphics}
              />
              <Container className='pov-info'>
                <Word
                  textStyle='normalReg'
                  variant='span'
                  value={idPov ? 'POV :' : ''}
                />
                <Word
                  textStyle='normalBold'
                  variant='span'
                  value={idPov ? idPov.toString() : ''}
                />
              </Container>
              {/* radio buttons */}
              <div style={{ width: '40vh', display: 'flex', justifyContent: 'space-around', alignItems: 'center', height: '5vh', marginLeft: '30px' }}>
                {radioButtonComponent(showFilters, dataToAdd, setDataSelected, warningMessageCss)}
              </div>
              {/* dropdownlist for piezometers */}
              {piezometersDropdownlistComponent(piezoOptions,piezoSelected,setPiezoSelected,warningMessageCss,piezoMeasures !== null
               ? anyMeasuresFindForPiezometrySelected(piezoMeasures, piezoSelected)
              : false
              )}
              {piezoOptions !== null && piezoOptions.length > 0 &&
                <Button automatedTestId="button-submit" className="export-btn" onClick={() => savePiezoParameter(piezoSelected, piezoParameter, setPiezoParameter, toastSucess, toastError)} mode="plain">
                  <Word variant="span" textStyle="normalBold" value="Paramétrer" />
                </Button>}
            </div>
            <Container className='pompe-info'>
              <Word
                textStyle='normalReg'
                automatedTestId='pompe-derniere-remontee'
                variant='p'
                value={debit ? 'Dernière remontée :' : ''}
              />
              <Word
                textStyle='normalBold'
                automatedTestId='pompe-date'
                variant='p'
                value={debit ? new Date (debit?.time).toLocaleDateString() : ''}
              />
            </Container>
          </div>
          {/* time graph */}
          <Container
            className='global-data-pr-container'
            automatedTestId='global-data-pr-container'
          >
            {/* temp and number graphics */}
              <>
                <PrMrGraphicsContainer
                  data={{ allMeasures, allMeasuresLevelsPr, piezoMeasures }}
                  module={prType}
                  code={code}
                  piezoCode={piezoSelected}
                  dataSelected={dataSelected}
                  handleShowHideGraphics={handleShowHideGraphics}
                  showHide={reziseGraphics}
                />
              </>
          </Container>
      </Container>
    </>
  );
};

export const Styles = createGlobalStyle`

.global-pr-container .pov-info {
  flex-direction : row !important;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
  .sds-reset-style .loaderPrMrGraphics {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .dropdownlist-container{
    position: relative;
    bottom: 1vh;
  }
  .sds-m-radio-list .radio-item{
    margin-bottom: 0;
  }
  .global-pr-container{
    margin-left: 32vh;
    margin-right: auto;
    .search-detail-pr{
      flex-direction: row;
      gap: 10px;
      display: inline-flex;
      align-items: center;
    }
  .pompe-info{
    flex-direction: row;
    margin-bottom: 10px;
    .warning{
      flex-direction: row; 
    }
    #warning-text{
      margin-left:5px;
      color:#FE3123
    }
    .warning-logo{
      margin-left:20px;
    }
    #pompe-derniere-remontee{
      margin-right: 5px;
    }
    #pompe-q{
      margin-right: 5px;
    }
  }
  .pov-info{
    flex-direction: row;
    align-items: center;
    gap: 5px;
    margin-left: 30px;
    margin-right: -60px;
  }
  .sds-container.sds-m-card.global-data-pr-container{
    overflow: unset;
    width: 90vw;
    }
`;
export default PrMrDetail;
